// extracted by mini-css-extract-plugin
export default {"point":"PointName_point__trV-x"};